<template>
  <div class="row row-box">
    <div class="col-xl-2 col-lg-6 col-md-6 col-sm-12 col-box">
      ชื่อห้องประชุม
      <div>
        <el-select
          v-model="roomIdSelect"
          filterable
          clearable
          placeholder="เลือกประเภทห้อง"
          class="select el-full"
        >
          <el-option
            v-for="room in roomConferenceTitleDropdown"
            :key="room.id"
            :value="room.id"
            :label="room.title"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-box">
      <span>ช่วงวันที่*</span>
      <div class="el-full">
        <el-date-picker
          class="el-full"
          v-model="roomDateRangeSelect"
          type="dates"
          format="dd-MM-yyyy"
          placeholder="เลือกวันที่"
        ></el-date-picker>
      </div>
    </div>
    <div class="col-xl-3 col-lg-5 col-lg-6 col-sm-6 col-box">
      <span>ช่วงเวลา</span>
      <div>
        <el-select
          class="el-full"
          v-model="timeDurationSelect"
          filterable
          clearable
          placeholder="เลือกช่วงเวลา"
        >
          <el-option
            v-for="timeDuration in timeDurationDropdown"
            :key="timeDuration.id"
            :value="timeDuration"
            :label="timeDuration.label"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-lg-6 col-sm-6 col-box">
      <span>จำนวนคน</span>
      <el-input
        class="el-full"
        v-model="numberOfPeopleSelect"
        type="number"
        placeholder="เลือกจำนวนคน"
      ></el-input>
    </div>
    <div class="col-xl-2 col-lg-3 col-lg-12 col-sm-12 col-box">
      <sc-button variant="orange-cc" class="search-button" @click="handleSearch"
        >ค้นหา</sc-button
      >
    </div>
  </div>
</template>

<script>
import { DatePicker, Input, Option, Select } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import {
  timeDurationDropdown
} from "../VariableStatic";
import { DateTime } from "luxon";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    "el-option": Option,
    "el-select": Select,
    "el-date-picker": DatePicker,
    "el-input": Input,
    "sc-button": ScButton,
  },
  data() {
    return {
      roomIdSelect: null,
      timeDurationSelect: null,
      roomDateRangeSelect: null,
      numberOfPeopleSelect: null,
      timeDurationDropdown,
      roomConferenceTitleDropdown: []
    };
  },
  created() {
    this.setupRoomConferenceTitleDropdown();
  },
  methods: {
    handleSearch() {
      if (!this.roomDateRangeSelect || this.roomDateRangeSelect.length === 0) {
        alert('กรุณาเลือก "ช่วงวันที่"');
        return
      }

      const roomId = this.roomIdSelect || undefined;
      const timeDurationSelect = this.timeDurationSelect
        && this.timeDurationSelect.value || undefined;
      const numberOfPeople = +this.numberOfPeopleSelect || undefined;
      const dateSelect = this.roomDateRangeSelect.map(
        (dateSelect) => DateTime.fromJSDate(dateSelect).toFormat("yyyy-MM-dd")
      )

      const query = {
        room_id: roomId,
        time_duration: timeDurationSelect,
        number_of_people: numberOfPeople,
        date: dateSelect
      }

      this.$router.replace({
        name: "ConferenceSearchItem",
        query
      });
    },
    async setupRoomConferenceTitleDropdown() {
      this.roomConferenceTitleDropdown = await this.fetchConferenceProjectList();
    },
    async fetchConferenceProjectList() {
      const query = {
        titleonly: true
      };

      try {
        return await baanRueJaiClient.others.conference.getConferenceProjectList(
          undefined,
          query
        );
      } catch (err) {
        console.error(err)
        return [];
      }
    }
  },
  watch: {},
  computed: {},
};
</script>

<style lang='scss' scoped>
@import "../../css/otherWebVariables";
.row-box {
  padding: 20px;
}

.col-box {
  text-align: left;
  padding-bottom: 10px;
}

.el-full {
  width: 100%;
}

.search-button {
  margin-top: 21px;
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.el-button.is-plain:focus,
.el-button.is-plain:hover {
  border-color: $color-orange !important;
  color: $color-orange !important;
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/components/SearchItem.vue